import {effectivePermissions, canBrowse} from './effectivePermissions';

export const hasLookupRole = role => {
  try {
    const roles = effectivePermissions();
    if (role === 'ROLE_MATERIAL_READ') {
      if (roles.includes('ROLE_MATERIAL_BROWSER')) return true;
      return ['MATERIAL', 'MATERIAL_PRODUCTION', 'MATERIAL_TRADING', 'MATERIAL_OPERATIONS']
        .some(prefix => ['READ', 'WRITE'].some(action => roles.includes(`ROLE_${prefix}_${action}`)));
    }
    if (role === 'ROLE_CUSTOMER_ORDER_READ') {
      return canBrowse(role) || roles.includes('ROLE_CUSTOMER_ORDER_SETTINGS');
    }
    return canBrowse(role);
  } catch (_) {
    return false;
  }
};

export const loadOrderLookup = (api, url, role, enabled = true) => enabled && hasLookupRole(role)
  ? api('get', url)
  : Promise.resolve({data: {data: {items: []}}});

// Preserve labels and IDs of existing relations even when their full catalogue is unavailable.
export const includeOrderRelations = (rows, relations) => [...rows, ...relations.filter(relation =>
  relation && typeof relation === 'object' && relation.id && !rows.some(row => row.id === relation.id)
)];
